import Graphic from './Graphic';
export default Graphic;